import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
//import { Clock } from "lucide-react";
import { memo, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { TIME_OPTIONS, type TimePickerProps } from "./types";

export const TimePicker = memo(function TimePicker({ day, period, label, fieldName, options }: TimePickerProps) {
  const form = useFormContext();

  const fieldName_full = `openingHours.${day}.${period}.${fieldName}`;

  // Use filtered options if provided, otherwise use all TIME_OPTIONS
  const timeOptions = options || TIME_OPTIONS;

  const handleValueChange = useCallback(
    (value: string) => {
      form.setValue(fieldName_full, value, { shouldValidate: true });
    },
    [form, fieldName_full]
  );

  return (
    <FormField
      control={form.control}
      name={fieldName_full}
      render={({ field, fieldState }) => (
        <div className="flex flex-col space-y-2">
          <div className={cn("text-sm font-medium text-gray-700", fieldState.invalid && "text-destructive")}>{label}</div>
          <FormItem>
            <FormControl>
              <Select value={field.value} onValueChange={handleValueChange}>
                <SelectTrigger className="h-10 w-full border-gray-200 bg-white" aria-invalid={fieldState.invalid}>
                  {/*<Clock className="mr-2 h-4 w-4 text-gray-400" />*/}
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {timeOptions.map((time) => (
                    <SelectItem key={time} value={time}>
                      {time}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        </div>
      )}
    />
  );
});
